import { fmtMoney } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";

export const CategoryRevenueGrid = ({ data }) => {
  if (!data?.category_revenue?.length) return null;
  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-serif font-semibold mb-5">Where {data.year} revenue comes from</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="category-revenue-grid">
        {data.category_revenue.map((c) => (
          <Card key={c.category} className="shadow-sm" data-testid={`category-revenue-${c.category}`}>
            <CardContent className="p-4">
              <p className="text-xs uppercase tracking-wide text-muted-foreground">{c.category}</p>
              <p className="text-xl font-serif font-semibold mt-1">{fmtMoney(c.amount)}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
